import { render, staticRenderFns } from "./aftermarket.vue?vue&type=template&id=88abd9e4&scoped=true"
import script from "./aftermarket.vue?vue&type=script&lang=js"
export * from "./aftermarket.vue?vue&type=script&lang=js"
import style0 from "./aftermarket.vue?vue&type=style&index=0&id=88abd9e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88abd9e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88abd9e4')) {
      api.createRecord('88abd9e4', component.options)
    } else {
      api.reload('88abd9e4', component.options)
    }
    module.hot.accept("./aftermarket.vue?vue&type=template&id=88abd9e4&scoped=true", function () {
      api.rerender('88abd9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/address/components/aftermarket.vue"
export default component.exports